module.exports = __webpack_public_path__ + "static/img/free-use.4b6819ff.png";